import { Component, OnInit, Inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { LayoutService } from '@huge-monorepo/portal/layout';
import { NavigationService } from '@huge-monorepo/portal/services';
import { UserRightsService } from '@huge-monorepo/portal/services';
import { GenericService } from '@huge-monorepo/portal/services';
import { LoginService } from '@huge-monorepo/portal/services';

import { ToastrService } from 'ngx-toastr';
import { MemoryService } from '@huge-monorepo/portal/services';
import { ToolsService } from '@huge-monorepo/portal/services';

import { TitleService } from '@huge-monorepo/portal/services';
import { Endpoints } from '@huge-monorepo/portal/config';
import { Routes } from '@huge-monorepo/portal/config';
import { SharedTeltonikaSingletonService, SharedGenericSingletonService, SharedLoginSingletonService, SharedUsageDataSourceSingletonService } from '@huge-monorepo/shared/services';
import { TeltonikaService } from '@huge-monorepo/portal/services'
import { Environment } from '@huge-monorepo/portal/config';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {
  time: any;
  url: string;
  groupAdmin = false;

  constructor(
    private navigationService: NavigationService,
    private layoutService: LayoutService,
    private genericService: GenericService,
    private loginService: LoginService,
    private endpoints: Endpoints,
    private toastService: ToastrService,
    private auth: UserRightsService,
    private memory: MemoryService,
    public breakpointObserver: BreakpointObserver,
    public router: Router,
    private tools: ToolsService,
    private routes: Routes,
    private titleService: TitleService,
    private teltonikaSingleton: SharedTeltonikaSingletonService<TeltonikaService>,
    private genericSingleton: SharedGenericSingletonService<GenericService>,
    private usageDataSourceSingleton: SharedUsageDataSourceSingletonService,
    private loginSingleton: SharedLoginSingletonService<LoginService>,
    private teltonikaService: TeltonikaService,
    @Inject(Environment) private environment: any,
  ) {
    // router.events
    //   .pipe(filter((event) => event instanceof NavigationEnd))
    //   .subscribe((_event: NavigationEnd) => {
    //     // this.navigationService.SetCurrentRoute(router.url);
    //     // titleService.setPageTitle()

    //   });
    this.init();
  }

  init() {
    // console.log("init called");
    this.setUpSharedSingletons();
    this.router.events.subscribe((val) => {
      if (val instanceof NavigationEnd === true) {
        if (val['url'] != null) {
          this.url = val['url'] as string;
          this.titleService.setPageTitle(this.url);
          // Delete device details memory if navigating away from devices screen
          if (this.url != '/Devices' && (!this.url.includes('Device') || !this.url.includes('cdr'))) {
            this.memory.removeDetails();
          }
          // Check if user has access to User management screen
          if (this.auth.IsLoggedIn() && this.url == '/UserManagement') {
            this.groupAdmin = this.auth.IsGroupAdmin();
            if (!this.groupAdmin) {
              this.toastService.error('You do not have rights to access this screen.', 'Unauthorised', { timeOut: 8000 });
              this.router.navigate([this.routes.Home]);
            }
          }
          // console.log(this.auth.IsImpersonating());
          if (this.url == '' || this.url == '/') {
            // Login screen hit
            if (!this.auth.IsLoggedIn()) {
              console.log('Bro is not logged in');
            } else {
              console.log('Bro is already logged in');
              this.toastService.success('You can continue your active session.', 'Welcome back', { timeOut: 8000 });
              this.router.navigate([this.routes.Home]);
            }
          } else {
            // console.log("Bro is at other page so check things");
            const skipLoginCheck = this.url.includes('/ForgotPassword') || this.url.includes('/ResetPassword') || this.url.includes('/Register');

            if (!skipLoginCheck) {
              const token = this.auth.GetToken();
              if (token == null) {
                this.toastService.info('You do not have an active session.', 'Please Login', { timeOut: 8000 });
                localStorage.clear();
                this.auth.Logout();
                return;
              } else {
                const expiry = this.tools.GetExpiryTimeFromToken(token);
                const diff = this.tools.GetTimeDifference(expiry);
                if (diff < 10000) {
                  this.toastService.info('Your session has expired.', 'Please Login', { timeOut: 8000 });
                  localStorage.clear();
                  this.auth.Logout();
                  return;
                }
              }

              const diff = this.auth.calculateRefreshTime();

              if (diff < 30000) {
                this.inactivityTime();
                setTimeout(() => {
                  this.refreshToken();
                });
              } else {
                setTimeout(() => {
                  this.refreshToken();
                }, diff - 1000);
              }
            }
          }
        }
      }
    });
  }

  ngOnInit(): void {
    this.breakpointObserver
      .observe([
        '(max-width: 320px)',
        '(min-width: 321px) and (max-width: 375px)',
        '(min-width: 376px) and (max-width: 425px)',
        '(min-width: 426px) and (max-width: 768px)',
        '(min-width: 769px) and (max-width: 1024px)',
        '(min-width: 1025px)',
      ])
      .subscribe((state: BreakpointState) => {
        if (state.breakpoints['(max-width: 320px)']) {
          this.layoutService.screenSize = 1;
        }
        if (state.breakpoints['(min-width: 321px) and (max-width: 375px)']) {
          this.layoutService.screenSize = 2;
        }
        if (state.breakpoints['(min-width: 376px) and (max-width: 425px)']) {
          this.layoutService.screenSize = 3;
        }
        if (state.breakpoints['(min-width: 426px) and (max-width: 768px)']) {
          this.layoutService.screenSize = 4;
        }
        if (state.breakpoints['(min-width: 769px) and (max-width: 1024px)']) {
          this.layoutService.screenSize = 5;
        }
        if (state.breakpoints['(min-width: 1025px)']) {
          this.layoutService.screenSize = 6;
        }
      });

    window.addEventListener(
      'dragover',
      function (e) {
        e.preventDefault();
        e.dataTransfer.effectAllowed = 'none';
        e.dataTransfer.dropEffect = 'move';
      },
      false,
    );
    window.addEventListener(
      'drop',
      function (e) {
        e.preventDefault();
        e.dataTransfer.effectAllowed = 'none';
        e.dataTransfer.dropEffect = 'move';
      },
      false,
    );
  }

  inactivityTime = () => {
    window.onload = this.resetTimer;
    document.onmousemove = this.resetTimer;
    document.onkeypress = this.resetTimer;
  };

  resetInactivityTime() {
    window.onload = null;
    document.onmousemove = null;
    document.onkeypress = null;
  }

  resetTimer = () => {
    clearTimeout(this.time);
    this.time = null;
    this.time = setTimeout(() => {
      this.toastService.info('Are you there?', 'You seem to be inactive and will be logged out in 2 minutes if no activity is registered.', { timeOut: 60000 });
      clearTimeout(this.time);
      this.time = null;
      this.time = setTimeout(() => {
        this.toastService.info('You have been logged out for being inactive for more than 30 minutes.', 'Please login again', { timeOut: 120000 });
        clearTimeout(this.time);
        this.resetInactivityTime();
        this.auth.Logout();
      }, 120000);
    }, 3600000);
  };

  refreshToken() {
    this.genericService.GET(this.endpoints.REFRESH_TOKEN).subscribe(
      (res) => {
        const token = res['body'];
        if (token && token['token'] != '') {
          this.auth.UpdateToken(token['token']);
          const nextRefresh = this.auth.calculateRefreshTime();
          setTimeout(() => {
            this.refreshToken();
          }, nextRefresh);
        }
      },
      (err) => {
        console.log(err);
      },
    );
  }

  setUpSharedSingletons() {
    this.loginSingleton.setService(this.loginService);
    this.loginSingleton.setIsCustomer(true);
    this.teltonikaSingleton.setService(this.teltonikaService);
    this.teltonikaSingleton.setIsCustomer(true);
    this.genericSingleton.setGenericService(this.genericService);
    this.genericSingleton.setIsCustomer(true);
    this.genericSingleton.setApiLink(this.environment.apiLink);
    this.genericSingleton.setIsLightMode(false);
    this.genericSingleton.setPath();
    this.genericSingleton.setEndpoints(this.endpoints);
    this.usageDataSourceSingleton.setGenericService(this.genericSingleton);
    this.usageDataSourceSingleton.setAuthService(this.auth);
    this.usageDataSourceSingleton.startTimer();
  }
}
